// extracted by mini-css-extract-plugin
module.exports = {"accessIcon":"AccessControls_accessIcon__6dl7x","denied":"AccessControls_denied__2zp-e","accepted":"AccessControls_accepted__160wo"};